/** Default rows per page on `/scribe` (list-clinic `pageLength`). */
export const SCRIBE_DEFAULT_PAGE_SIZE = 50;
